@if (active()) {
  @if (loading) {
    <ul aria-hidden="true">
      <li>{{ 'autocomplete.loading' | translate }}</li>
    </ul>
  }
  @if (!loading && searched && !data.length) {
    <ul aria-hidden="true">
      <li>{{ 'autocomplete.no_result' | translate }}</li>
    </ul>
  }
  @if (!loading && data.length) {
    <ul class="autocomplete__results" role="listbox" id="autocompleteResults">
      @for (item of data; track item; let i = $index) {
        <li
          role="option"
          (click)="onClick(item)"
          (keypress.enter)="onClick(item)"
          attr.id="option-{{ i }}"
          [class.autocomplete__active]="i == activeItem"
          [attr.aria-selected]="i == activeItem"
					[attr.aria-label]="
						(item | parseInAdds) + ', ' + ('autocomplete.clickable' | translate)
					"
          >
          {{ item | parseInAdds }}
        </li>
      }
    </ul>
  }
}
